import './CustomContainer.scss'

const CustomContainer = ({ children, minimized = false }) => {
  return <div className={`custom-container${minimized ? ' minimized' : ''}`}>{children}</div>
}

export default CustomContainer
